// extracted by mini-css-extract-plugin
export default {"block":"_2q4pz3Lk","pulse":"_29VCqw9G"};